import script from "./UsuarioAvisos.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioAvisos.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioAvisos.vue?vue&type=style&index=0&id=af5268b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af5268b6"]])

export default __exports__